import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'index',
  redirect: '/index',
  component: () => import('@/views/index/index'),
  children: [{
      path: 'index',
      name: 'home',
      component: () => import('@/views/pages/index'),
      meta: { title: '首页', activeMenu: 'index' }
    },
    {
      path: '123',
      name: 'electronic',
      component: () => import('@/views/pages/Electronic'),
      meta: { title: 'help', activeMenu: '123' }
    },
    {
      path: 'project',
      name: 'project',
      component: () => import('@/views/pages/Project'),
      meta: { title: 'help', activeMenu: 'project' }
    },
    {
      path: 'help',
      name: 'help',
      component: () => import('@/views/pages/HelpCenter'),
      meta: { title: 'help', activeMenu: 'help' }
    },
    {
      path: 'cont',
      name: 'cont',
      component: () => import('@/views/pages/Details'),
      meta: { title: 'help', activeMenu: 'cont' }
    },
    {
      path: 'detail',
      name: 'detail',
      component: () => import('@/views/pages/Details'),
      meta: { title: 'detail', activeMenu: 'help' }
    },
    {
      path: 'search',
      name: 'search',
      component: () => import('@/views/pages/Search'),
      meta: { title: 'help', activeMenu: 'search' }
    },
    {
      path: 'valid',
      name: 'eveGuarantee',
      component: () => import('@/views/pages/EVEGuarantee'),
      meta: { title: 'valid', activeMenu: 'valid' }
    },
    {
      path: 'order',
      name: 'OrderSearch',
      component: () => import('@/views/pages/OrderSearch'),
      meta: { title: 'order', activeMenu: 'order',noCache:true}
    },
    {
      path: 'guaranteeapply/:guaranteeType',
      name: 'GuaranteeApply',
      component: () => import('@/views/pages/GuaranteeApply'),
      meta: { title: 'guaranteeapply', activeMenu: 'guaranteeapply' }
    },
    {
      path: 'guaranteeApply/:guaranteeType/:orderSn',
      name: 'GuaranteeApply',
      component: () => import('@/views/pages/GuaranteeApply'),
      meta: { title: 'guaranteeapply', activeMenu: 'guaranteeapply' }
    },
     {
      path: 'applypay',
      name: 'ApplyPay',
      component: () => import('@/views/pages/ApplyPay'),
      meta: { title: 'applypay', activeMenu: 'applypay' }
    }
  ]
}]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  // scrollBehavior(to, from, saveTop) { if (saveTop) { return saveTop } else { return { x: 0, y: 0 } } },
  scrollBehavior: () => ({ y: 0 }),
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js